import styles from "./ImageCard.module.scss";

const ImageCard = ({ image, alt, thumbnail, onClick, shadow }) => {
  return (
    <div className={`${styles.card} ${shadow && styles.shadow}`}>
      <img onClick={() => onClick(image)} alt={alt} src={thumbnail} />
    </div>
  );
};

export default ImageCard;
